var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "announcement-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.66732 16.3333L6.50441 23.6817C6.55607 23.8883 6.5819 23.9917 6.61247 24.0819C6.91101 24.9633 7.70476 25.583 8.63226 25.6589C8.7272 25.6667 8.83372 25.6667 9.04674 25.6667C9.3135 25.6667 9.44688 25.6667 9.55924 25.6558C10.6698 25.5481 11.5487 24.6692 11.6564 23.5586C11.6673 23.4462 11.6673 23.3128 11.6673 23.0461V6.41667M21.584 15.75C23.8391 15.75 25.6673 13.9218 25.6673 11.6667C25.6673 9.4115 23.8391 7.58333 21.584 7.58333M11.959 6.41667H7.58398C4.68449 6.41667 2.33398 8.76717 2.33398 11.6667C2.33399 14.5662 4.68449 16.9167 7.58398 16.9167H11.959C14.0198 16.9167 16.5408 18.0214 18.4857 19.0816C19.6203 19.7001 20.1876 20.0094 20.5592 19.9638C20.9037 19.9216 21.1642 19.7669 21.3662 19.4846C21.584 19.1802 21.584 18.571 21.584 17.3527V5.98067C21.584 4.76233 21.584 4.15316 21.3662 3.8487C21.1642 3.56638 20.9037 3.41168 20.5592 3.36948C20.1876 3.32398 19.6203 3.63323 18.4857 4.25175C16.5408 5.31196 14.0198 6.41667 11.959 6.41667Z",
    stroke: "#003CE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement02);
export default __webpack_public_path__ + "static/media/announcement-02.cfe7a8e83d5a630b70adaf0872a62c72.svg";
export { ForwardRef as ReactComponent };